import { Action } from 'redux'

export const USER_LOGOUT = 'USER_LOGOUT'

export interface ILogoutAction extends Action<string> {
  type: string
}

export type Actions = ILogoutAction
